import { Injectable } from "@angular/core";
import { Observable, of, switchMap } from "rxjs";
import { CreateAdventure, Adventure, UpdateAdventure } from "../models/adventure.model";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: 'root',
})
export class AdventureService {

	constructor(
		private http: HttpClient,

	) {}

	public getDraftAdventures(): Observable<Adventure[]> {
		return this.http.get<Adventure[]>(`${environment.SERVICES.LESSON}adventures-draft`)
			.pipe(
				switchMap(res => {
					return of(res);
				})
			)
	}

	public getLiveAdventures(): Observable<Adventure[]> {
		return this.http.get<Adventure[]>(`${environment.SERVICES.LESSON}adventures`)
			.pipe(
				switchMap(res => {
					return of(res);
				})
			)
	}

	public createAdventure(data: CreateAdventure): Observable<{uid: string}> {
		return this.http.post<{uid: string}>(`${environment.SERVICES.LESSON}adventures-draft`, data);
	}

	public removeAdventure(uid: string): Observable<void> {
		return this.http.delete<void>(`${environment.SERVICES.LESSON}adventures-draft/${uid}`);
	}

	public updateAdventure(uid: string, adventure: Adventure) {
		const updateInfo: UpdateAdventure = Object.assign({}, adventure);

		delete updateInfo.uid;

		return this.http.put<void>(`${environment.SERVICES.LESSON}adventures-draft/${uid}`, updateInfo);
	}

	public pushAdventuresToLive(uids: string[]) {
		return this.http.post<void>(`${environment.SERVICES.LESSON}adventures`, { adventureIds: uids });
	}

	public publishAdventure(uid: string, phase: boolean): Observable<boolean> {
		const updateInfo = {
			releasePhase: phase ? 'Published' : 'Not Published'
		};

		return this.http.put<boolean>(`${environment.SERVICES.LESSON}adventures/${uid}`, updateInfo);
	}

	public validateAdventure(uid: string, isQAValid: boolean): Observable<boolean> {
		const updateInfo = {
			isValid: isQAValid
		};

		return this.http.put<boolean>(`${environment.SERVICES.LESSON}adventures-draft/${uid}/qaValid`, updateInfo);
	}
}
